import React, { useState, useEffect } from "react"
import API from "../../api/axios" // Import API for API call
import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
  Label,
  Input,
  FormFeedback,
  Form,
} from "reactstrap"

// validation Validation
import * as Yup from "yup"
// import { usevalidation } from "validation"
import { useFormik } from "formik"
//redux
import { useSelector, useDispatch } from "react-redux"
import Select from "react-select"
import withRouter from "components/Common/withRouter"

// actions

import { useLocation, useNavigate } from "react-router-dom"

import { ToastContainer, toast } from "react-toastify"
import DeleteModel from "./DeleteModel"
import PasswordResetModel from "pages/User/PasswordResetModel"

const UserProfile = () => {
  //meta title
  document.title = "Profile | Skote - React Admin & Dashboard Template"

  const dispatch = useDispatch()
  const location = useLocation()
  // const userData = location.state?.userData
  const navigate = useNavigate()

  const [userData, setUserData] = useState(location.state?.userData || {})
  const [allSpecialities, setAllSpecialities] = useState([])
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [showPasswordModal, setShowPasswordModal] = useState(false)

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: userData.id,
      fname: userData?.fname || "",
      lname: userData?.lname || "",
      email: userData?.email || "",
      gender: userData?.gender || "",
      phone: userData?.phone || "",
      role: userData?.role || "",
      serviceId: userData?.Services?.map(s => s.id) || [],
      isActive: userData?.isActive || "",
    },
    validationSchema: Yup.object().shape({
      fname: Yup.string()
        .min(2, "First name must be at least 2 characters")
        .max(50, "First name cannot exceed 50 characters")
        .required("First name is required"),
      lname: Yup.string()
        .min(2, "Last name must be at least 2 characters")
        .max(50, "Last name cannot exceed 50 characters")
        .required("Last name is required"),
      email: Yup.string().email("Invalid email").required("Email is required"),
      gender: Yup.string()
        .oneOf(["male", "female"], "Select a valid gender")
        .required("Gender is required"),
      phone: Yup.string()
        .matches(/^\d{10}$/, "Phone number must be 10 digits")
        .required("Phone number is required"),

      role: Yup.string().required("Role is required"),

      serviceId: Yup.array()
        .of(Yup.number())
        .when("role", (role, schema) => {
          return role === "doctor"
            ? schema.min(1, "At least one speciality is required for doctors")
            : schema.notRequired()
        }),

      isActive: Yup.string().required("isActive is required"),
    }),
    onSubmit: async values => {
      console.log("Submitting values:", values)
      await updatePatient1(values)
    },
  })

  const { isSubmitting } = validation
  console.log("valiadation error", validation?.errors)

  const updatePatient1 = async updatedData => {
    try {
      const authToken = localStorage.getItem("authToken")
      console.log("Sending updated data:", updatedData)

      const response = await API.put(
        `/users/${updatedData.id}`,
        updatedData,
        {
          headers: {
            Authorization: `Bearer ${authToken} `,
            "Content-Type": "application/json",
          },
        },
      )

      if (response.status === 200) {
        toast.success("User updated successfully ", { autoClose: 2000 })

        setTimeout(() => {
          navigate("/user")
        }, 2000)
      } else {
        toast.error("Failed to update patient. Please try again.")
      }
    } catch (error) {
      console.error("Error updating patient data:", error)
      toast.error("Error updating patient.")
    }
  }

  const handleDelete = () => {
    if (!userData || !userData.id) {
      toast.error("Invalid user data.")
      return
    }
    setShowDeleteModal(true) // open modal
  }

  // delete user data
  const confirmDelete = async () => {
    try {
      const authToken = localStorage.getItem("authToken")

      const response = await API.delete(
        `/users/${userData.id}`,
        {
          headers: {
            Authorization: `Bearer ${authToken} `,
            "Content-Type": "application/json",
          },
        },
      )

      if (response.status === 200) {
        toast.success("User deleted successfully!", { autoClose: 2000 })
        setShowDeleteModal(false)
        setTimeout(() => {
          navigate("/user")
        }, 2000)
      } else {
        toast.error("Failed to delete user. Please try again.")
      }
    } catch (error) {
      console.error("Error deleting user:", error)
      toast.error("Error deleting user.")
    }
  }

  // useEffect(() => {
  //   console.log("User data from location:", userData)
  // }, [userData])

  useEffect(() => {
    const fetchSpecialities = async () => {
      try {
        const authToken = localStorage.getItem("authToken")
        const response = await API.get("/services", {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          },
        })
        const uniqueSpecialities = Array.from(
          new Set(response.data.map(s => JSON.stringify(s))),
        ).map(s => JSON.parse(s))
        setAllSpecialities(uniqueSpecialities)
      } catch (err) {
        console.error("Error fetching services", err)
      }
    }

    fetchSpecialities()
  }, [])

  return (
    <React.Fragment>
      <ToastContainer />
      <div className="page-content p-0">
        <Container fluid>
          <h4 className="card-title mb-4">Change User Profile</h4>

          <Card>
            <CardBody>
              <form
                action=""
                className="form-horizontal"
                onSubmit={validation.handleSubmit}
              >
                <Row>
                  <Col md={4}>
                    <div className="form-group">
                      <Label className="form-label">First Name</Label>
                      <Input
                        name="fname"
                        // value={name}
                        className="form-control"
                        placeholder="First Name"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.fname || ""}
                        invalid={
                          validation.touched.fname && validation.errors.fname
                            ? true
                            : false
                        }
                      />
                      {validation.touched.fname && validation.errors.fname && (
                        <div className="text-danger">
                          {validation.errors.fname}
                        </div>
                      )}
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="form-group">
                      <Label className="form-label">lname</Label>
                      <Input
                        name="lname"
                        // value={name}
                        className="form-control"
                        placeholder=" Last Name"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.lname || ""}
                        invalid={
                          validation.touched.lname && validation.errors.lname
                            ? true
                            : false
                        }
                      />

                      {validation.touched.lname && validation.errors.lname && (
                        <div className="text-danger">
                          {validation.errors.lname}
                        </div>
                      )}
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="form-group">
                      <Label for="gender">Gender</Label>
                      <Input
                        type="select"
                        name="gender"
                        id="gender"
                        className="form-control"
                        placeholder=" Gender"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.gender}
                        invalid={
                          validation.touched.gender && validation.errors.gender
                            ? true
                            : false
                        }
                      >
                        <option value="">Select Gender</option>{" "}
                        {/* Default placeholder */}
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                      </Input>
                      {validation.touched.gender &&
                        validation.errors.gender && (
                          <FormFeedback type="invalid">
                            {validation.errors.gender}
                          </FormFeedback>
                        )}
                    </div>
                  </Col>
                </Row>

                <Row className="mt-3">
                  <Col md={4}>
                    <div className="form-group">
                      <Label className="form-label">Phone</Label>
                      <Input
                        name="phone"
                        // value={name}
                        className="form-control"
                        placeholder="+91 8378655768"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.phone || ""}
                        invalid={
                          validation.touched.phone && validation.errors.phone
                            ? true
                            : false
                        }
                      />
                      {validation.touched.phone && validation.errors.phone && (
                        <div className="text-danger">
                          {validation.errors.phone}
                        </div>
                      )}
                    </div>
                  </Col>

                  <Col md={4}>
                    <div className="form-group">
                      <Label className="form-label">Email</Label>
                      <Input
                        name="email"
                        // value={name}
                        className="form-control"
                        placeholder="donereaply@gmail.com"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.email || ""}
                        invalid={
                          validation.touched.email && validation.errors.email
                            ? true
                            : false
                        }
                      />
                      {validation.touched.email && validation.errors.email && (
                        <div className="text-danger">
                          {validation.errors.email}
                        </div>
                      )}
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="form-group">
                      <Label className="form-label">Role</Label>
                      <Input
                        type="select"
                        name="role"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.role}
                        invalid={
                          validation.touched.role && validation.errors.role
                            ? true
                            : false
                        }
                      >
                        <option value="">Select Role</option>
                        <option value="admin">Admin</option>
                        <option value="staff">Staff</option>
                        <option value="doctor">Doctor</option>
                      </Input>
                      {validation.touched.role && validation.errors.role && (
                        <div className="text-danger">
                          {validation.errors.role}
                        </div>
                      )}
                    </div>
                  </Col>
                  {validation.values.role === "doctor" && (
                    <div className="form-group">
                      <Label className="form-label">Speciality</Label>
                      <Select
                        name="serviceId"
                        isMulti
                        options={allSpecialities.map(s => ({
                          label: s.name,
                          value: s.id,
                        }))}
                        value={allSpecialities
                          .map(s => ({ label: s.name, value: s.id }))
                          .filter(option =>
                            validation.values.serviceId.includes(option.value),
                          )}
                        onChange={selectedOptions => {
                          const selectedIds = selectedOptions.map(
                            option => option.value,
                          )
                          validation.setFieldValue("serviceId", selectedIds)
                        }}
                        onBlur={validation.handleBlur}
                      />

                      {validation.touched.serviceId &&
                        validation.errors.serviceId && (
                          <div className="text-danger">
                            {validation.errors.serviceId}
                          </div>
                        )}
                    </div>
                  )}
                </Row>

                <Row className="mt-3">
                  <Col md={4}>
                    <div className="form-group">
                      <Label className="form-label">Status</Label>
                      <Input
                        type="select"
                        name="isActive"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.isActive}
                        invalid={
                          validation.touched.isActive &&
                          validation.errors.isActive
                        }
                      >
                        <option value="">Select Status</option>
                        <option value="true">Active</option>
                        <option value="false">Inactive</option>
                      </Input>

                      {validation.touched.isActive &&
                        validation.errors.isActive && (
                          <div className="text-danger">
                            {validation.errors.isActive}
                          </div>
                        )}
                    </div>
                  </Col>
                </Row>

                <div
                  className="text-center mt-4"
                  style={{
                    display: "flex",
                    gap: "10px",
                    justifyContet: "center",
                    alignItems: "center",
                  }}
                >
                  <Button
                    type="submit"
                    color="primary"
                    className="px-3 border"
                    disabled={isSubmitting}
                  >
                    Update User Profile
                  </Button>

                  <Button
                    type="button"
                    color="danger"
                    className="px-3 border"
                    onClick={handleDelete}
                  >
                    Delete User
                  </Button>

                  <Button
                    type="button"
                    color="secondary"
                    className="px-3 border"
                    onClick={() => navigate("/user")}
                  >
                    Cancel
                  </Button>

                  <Button
                    type="button"
                    color="primary"
                    className="px-3 border"
                    onClick={() => setShowPasswordModal(true)}
                  >
                    Reset Password
                  </Button>
                </div>
              </form>
            </CardBody>
          </Card>
        </Container>

        {/* Delete Confirmation Modal */}
        <DeleteModel
          isOpen={showDeleteModal}
          toggle={() => setShowDeleteModal(false)}
          entityName="user"
          entityLabel={`${userData.fname} ${userData.lname}`}
          onConfirm={confirmDelete}
        />

        <PasswordResetModel
          isOpen={showPasswordModal}
          toggle={() => setShowPasswordModal(false)}
            targetUser={userData}
        />
      </div>
    </React.Fragment>
  )
}

export default withRouter(UserProfile)
